import customProtocolCheck from 'legacy/src/utility/customProtocolCheck';

export const SECURE_BROWSER_STATUS_CHECKING = 'checking';
export const SECURE_BROWSER_STATUS_FOUND = 'found';
export const SECURE_BROWSER_STATUS_MISSING = 'missing';

export function openSecureBrowserLink(secureUrl, onBrowserStatusChange) {
  customProtocolCheck(
    secureUrl,
    () => onBrowserStatusChange(SECURE_BROWSER_STATUS_MISSING),
    null,
    () => onBrowserStatusChange(SECURE_BROWSER_STATUS_MISSING),
  );
}
